import { ITooltips } from './interfaces'

export const useState = (): UiState => {
  return {
    filterPanelPinned: false,
    filterPanelCollapsed: false,
    detailsPanelCollapsed: true,
    detailsPanelActiveTab: 'overview',
    tooltips: {
      'cruise-list-header-icon-schiff': {
        show: false,
        pos: { x: -12, y: 0 },
      },
      'cruise-list-header-icon-bett': {
        show: false,
        pos: { x: -12, y: 0 },
      },
      'cruise-list-header-icon-comfort-all-inclusive': {
        show: false,
        pos: { x: -12, y: 0 },
      },
      'cruise-list-header-icon-premium': {
        show: false,
        pos: { x: -12, y: 0 },
      },
      'cruise-list-header-icon-premium-all-inclusive': {
        show: false,
        pos: { x: -12, y: 0 },
      },
      'cruise-list-header-icon-classic': {
        show: false,
        pos: { x: 0, y: 0 },
      },
      'cruise-list-header-icon-classic-all-inclusive': {
        show: false,
        pos: { x: 0, y: 0 },
      },
      'cruise-list-header-icon-specials': {
        show: false,
        pos: { x: 0, y: 0 },
      },
      'details-order-order-button': {
        show: false,
        pos: { x: 0, y: 0 },
      },
      'details-order-order-button-fast': {
        show: false,
        pos: { x: 0, y: 0 },
      },
      'info-icon': {
        show: false,
        pos: { x: 0, y: 0 },
      },
      'rail-info-icon': {
        show: false,
        pos: { x: 0, y: 0 },
      },
      'flex-flight-info-icon': {
        show: false,
        pos: { x: 0, y: 0 },
      },
      'info-flex-flights': {
        show: false,
        pos: { x: -12, y: 0 },
      },
      'info-babies': {
        show: false,
        pos: { x: -12, y: 0 },
      },
    },
  }
}

export interface UiState {
  filterPanelPinned: boolean
  filterPanelCollapsed: boolean
  detailsPanelCollapsed: boolean
  detailsPanelActiveTab: string
  tooltips: ITooltips
}
